/*eslint-disable no-undef*/
/*global translate*/
import { connect } from 'react-redux'
import React, { Component, Fragment, useState } from 'react'

const { rxaget, rxChangeSlug, stringToColour} = global.rootRequire('classes/ulti')
const { changeColorAva, textAva } = global.rootRequire('classes/chat')
const chatDB = global.rootRequire('classes/indexedDB').default
const globalUser = global.rootRequire('classes/globalUser')

class RxAvatar extends Component {
  constructor(props, context) {
    super(props, context)
    this.state = {
      
    }
    // let group = this.props.info

    // console.log(user)

    // chatDB.users.get({id: user.partner_id}).then(oUser => {
    //   console.log('11122233334444')
    //   console.log(oUser)
    // })
    // if (!userInDB) {
    //   ogroup.flagDetail = false
    // }


  }

  async getUser() {
    let user = await chatDB.users.get({id: this.props.info.partner_id})
    console.log(user)
  } 

  render() {
    // console.log('11122233334444')
    let ele = this.props.info

    // console.log(ele.partner_id)
    // console.log(globalUser.users)
    this.getUser()
    

    return (
      <div className='zgroup_avatar'>           
        {(ele.avatar_url) && <img src={global.rxu.config.get_static + ele.avatar_url} alt='avatar_url' className='ava-group images-static' onError={(e) => {e.target.onerror = null; e.target.src = './images/default/static/avadefault.svg' }} /> } 

        {(!ele.avatar_url && globalUser.users[ele.partner_id] && globalUser.users[ele.partner_id]['profile_url']) && <img src={`${global.rxu.config.cdn_endpoint}` + globalUser.users[ele.partner_id]['profile_url']} alt='profile_url' data-id={'userava' + ele.partner_id} className='ava-usergroup images-static' onError={(e) => {e.target.onerror = null; e.target.src = './images/default/static/avadefault.svg' }} /> }           

        { !(ele.avatar_url || (globalUser.users[ele.partner_id] && globalUser.users[ele.partner_id]['profile_url']) ) &&<span className='ava-span' style={{ background: `${changeColorAva(rxaget(ele, 'group_id', ''))}` }}>
          {textAva(rxChangeSlug(rxaget(ele, 'group_fullname', ''), true))}
        </span>}
      </div> 
    )
  }
}

export default RxAvatar